import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\AccountController::view
 * @see app/Http/Controllers/AccountController.php:213
 * @route '/account/info/view'
 */
export const view = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: view.url(options),
    method: 'post',
})

view.definition = {
    methods: ["post"],
    url: '/account/info/view',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AccountController::view
 * @see app/Http/Controllers/AccountController.php:213
 * @route '/account/info/view'
 */
view.url = (options?: RouteQueryOptions) => {
    return view.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountController::view
 * @see app/Http/Controllers/AccountController.php:213
 * @route '/account/info/view'
 */
view.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: view.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AccountController::view
 * @see app/Http/Controllers/AccountController.php:213
 * @route '/account/info/view'
 */
    const viewForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: view.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AccountController::view
 * @see app/Http/Controllers/AccountController.php:213
 * @route '/account/info/view'
 */
        viewForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: view.url(options),
            method: 'post',
        })
    
    view.form = viewForm
/**
* @see \App\Http\Controllers\AccountController::update
 * @see app/Http/Controllers/AccountController.php:256
 * @route '/account/info/update'
 */
export const update = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: update.url(options),
    method: 'post',
})

update.definition = {
    methods: ["post"],
    url: '/account/info/update',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AccountController::update
 * @see app/Http/Controllers/AccountController.php:256
 * @route '/account/info/update'
 */
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountController::update
 * @see app/Http/Controllers/AccountController.php:256
 * @route '/account/info/update'
 */
update.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: update.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AccountController::update
 * @see app/Http/Controllers/AccountController.php:256
 * @route '/account/info/update'
 */
    const updateForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: update.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AccountController::update
 * @see app/Http/Controllers/AccountController.php:256
 * @route '/account/info/update'
 */
        updateForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: update.url(options),
            method: 'post',
        })
    
    update.form = updateForm
const info = {
    view: Object.assign(view, view),
update: Object.assign(update, update),
}

export default info